<div class="ml-[220px] flex min-h-[82vh] flex-col gap-2 py-1">
  <div class="inline-flex w-full items-end justify-between px-8 pt-2 pb-2">
    <h2 class="textTabsColor font-['Inter'] text-2xl font-semibold" i18n="@@offersTitle">Offers</h2>
  </div>

  <div class="flex flex-col gap-4 bg-gray-50/50 px-8 py-2">
    <div class="flex w-full flex-col gap-4">
      @if (loading()) {
        <app-loading />
      } @else {
        <div class="grid grid-cols-1 gap-4">
          @for (offer of offers(); track offerKey(offer)) {
            <div class="flex flex-col gap-2" (click)="onNavigateToDetails(offer)">
              <div
                class="group relative w-full cursor-pointer overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm transition-all hover:shadow-md">
                <div class="relative flex aspect-[21/5] w-full items-center justify-center overflow-hidden bg-gray-100">
                  @if (getImage(offer)) {
                    <img
                      [src]="getImage(offer)"
                      [alt]="offer.titleEn"
                      class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  } @else {
                    <div class="flex h-full w-full items-center justify-center bg-gray-50">
                      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 48 48">
                        <g class="fill-border-input">
                          <path d="M37.084 15.735a1 1 0 1 0 .448-1.949l-6.616-1.52a1 1 0 1 0-.448 1.948z" />
                          <path
                            fill-rule="evenodd"
                            d="M34 22a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-2a6 6 0 1 0 0-12a6 6 0 0 0 0 12M16.778 9.245c-.647-1.532-2.813-1.686-3.682-.263L6.292 20.115c-.785 1.284.092 2.924 1.623 3.033l11.866.846c1.53.11 2.644-1.388 2.06-2.77zm-1.967.768l-.009.012L8.01 21.14l.002.002l.01.004a.1.1 0 0 0 .036.007l11.867.846h.038a.1.1 0 0 0 .029-.015l-5.056-11.96l-.004-.01a.1.1 0 0 0-.054-.014a.13.13 0 0 0-.062.009l-.003.001v.001zM35.385 36.36a6 6 0 0 0-5.071-10.876l-10.876 5.07a6 6 0 1 0 5.071 10.877zm-15.102-3.992a4 4 0 1 0 3.381 7.25l4.466-2.083l-3.38-7.25zm9.66 4.322l-3.381-7.25l4.597-2.144a4 4 0 1 1 3.38 7.25z"
                            clip-rule="evenodd" />
                        </g>
                      </svg>
                    </div>
                  }
                  <div class="absolute inset-0 bg-black/5 opacity-0 transition-opacity group-hover:opacity-100"></div>
                </div>
              </div>
            </div>
          }
        </div>

        @if (offers().length === 0) {
          <div
            class="flex h-[300px] flex-col items-center justify-center rounded-2xl border-2 border-dashed border-gray-200 bg-white p-8 text-center">
            <p class="font-['Inter'] text-lg font-medium text-gray-500">
              {{ isArabic() ? "لا توجد عروض متاحة" : "No Offers Available" }}
            </p>
          </div>
        }
      }
    </div>

    @if (!loading() && totalItems() > 0) {
      <div class="mt-2 flex items-center justify-between border-t border-gray-100 pt-4">
        <div class="flex items-center text-[13px]">
          <span i18n="@@adminProductsPaginationShowing">Showing</span>
          <span class="textTabsColor mx-1">{{ (currentPage - 1) * pageSize + 1 }}</span>
          -
          <span class="textTabsColor mx-1">{{ mathMin(currentPage * pageSize, totalItems()) }}</span>
          <span i18n="@@adminProductsPaginationOf">of</span>
          <span class="textTabsColor mx-1">{{ totalItems() }}</span>

          <div class="mx-8 rounded border bg-white p-1">
            <select
              [(ngModel)]="pageSize"
              (ngModelChange)="onPageSizeChange()"
              class="cursor-pointer bg-transparent outline-none">
              <option [value]="2">2</option>
              <option [value]="10">10</option>
              <option [value]="20">20</option>
              <option [value]="50">50</option>
            </select>
          </div>
        </div>

        <div class="flex items-center gap-1">
          <button
            (click)="previousPage()"
            [disabled]="currentPage == 1"
            class="border-border hover-bg-surface-subtle flex h-[30px] w-[30px] items-center justify-center rounded-[6px] border bg-white transition-all disabled:cursor-not-allowed disabled:opacity-50">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline [attr.points]="isArabic() ? '9 18 15 12 9 6' : '15 18 9 12 15 6'"></polyline>
            </svg>
          </button>

          @for (page of getPageNumbers(); track $index) {
            @if (page == -1) {
              <span class="px-1 text-[13px]">...</span>
            } @else {
              <button
                (click)="goToPage(page)"
                [class]="
                  currentPage == page ? 'bgTabsColor text-white' : 'hover-bg-surface-subtle bg-white text-gray-700'
                "
                class="border-border flex h-[30px] w-[30px] items-center justify-center rounded-[6px] border text-[13px] font-[500] transition-all">
                {{ page }}
              </button>
            }
          }

          <button
            (click)="nextPage()"
            [disabled]="currentPage == totalPages"
            class="border-border hover-bg-surface-subtle flex h-[30px] w-[30px] items-center justify-center rounded-[6px] border bg-white transition-all disabled:cursor-not-allowed disabled:opacity-50">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline [attr.points]="isArabic() ? '15 18 9 12 15 6' : '9 18 15 12 15 6'"></polyline>
            </svg>
          </button>
        </div>
      </div>
    }
  </div>
</div>
